import { commonUtils, COUNTRY_FINLAND_ID, COUNTRY_PREFIX, REGION_OUTSIDE_FINLAND_ID } from './common_utils';
import { blueBarInit } from './advance_search_blue_bar';

export const advanceSearchCommon = {
    formName: 'advance_search',
    blueBar: [],
    isDesktopView: commonUtils.isSearchModalDesktopView(),

    /**
     * Sanitize serialized form fields for Nettikaravaani vertical
     * @param {string} sectionId - The section ID to serialize
     * @returns {string} - Sanitized serialized string
     */
    sanitizeSerializedFields(sectionId) {
        if (!commonUtils.isNettikaravaani()) {
            return $(`#${sectionId} :input`).serialize();
        }

        // Serialize only enabled fields (disabled fields like model dropdown should be excluded)
        let serialized = $(`#${sectionId} :input:enabled`).serialize();

        // Remove model= when make is empty (default state)
        // This handles the case where model field is not yet disabled on initial load
        if (sectionId === 'basicInfoFields' || sectionId === 'makeFields') {
            const makeValue = $(`#${sectionId} [name="make"]`).val();
            if (!makeValue || makeValue === '') {
                // Remove model parameter from serialized string
                serialized = serialized
                    .replace(/&?model=[^&]*(&|$)/, function (match, ending) {
                        return ending === '&' ? '&' : '';
                    })
                    .replace(/^&/, '');
            }
        }

        // Remove kilometers fields from basicInfoFields (they belong to a separate section visually)
        if (sectionId === 'basicInfoFields') {
            serialized = serialized
                .replace(/&?kilometersFrom=[^&]*(&|$)/, function (match, ending) {
                    return ending === '&' ? '&' : '';
                })
                .replace(/^&/, '');
            serialized = serialized
                .replace(/&?kilometersTo=[^&]*(&|$)/, function (match, ending) {
                    return ending === '&' ? '&' : '';
                })
                .replace(/^&/, '');
        }

        return serialized;
    },
    changeBlueBarClass(currentPanelId, sectionId) {
        let panelId = sectionId ? $(`#${sectionId}`).find('[id^=panel]').data('panel-id') : currentPanelId;
        let $section = $(`#panel_${panelId}`).closest('.post-ad__section');
        if ($(`#panel_${panelId} *`).serialize() !== blueBarInit[commonUtils.getVerticalName()][panelId]) {
            setTimeout(function () {
                $section.addClass('advance-search__section_changed');
                $section.find('.resetAdvField').show();
            }, 1);
        } else {
            $section.removeClass('advance-search__section_changed');
            $section.find('.resetAdvField').hide();
        }
    },
    showBlueBarOnLoad() {
        $('div[id^=panel]').each(function () {
            let currentPanelId = $(this).data('panel-id');
            advanceSearchCommon.blueBar[currentPanelId] = $(`#${this.id} *`).serialize();
            if (
                advanceSearchCommon.blueBar[currentPanelId] !==
                blueBarInit[commonUtils.getVerticalName()][currentPanelId]
            ) {
                let $panelId = $(`#panel_${currentPanelId}`);
                $panelId.closest('.post-ad__section').addClass('advance-search__section_changed');
                $panelId.closest('.advance-search__section_changed').find('.resetAdvField').show();
            }
        });
    },
    showHideResetIcon(sectionId) {
        let $section = $(`#advance_search #${sectionId}`).closest(
            this.isDesktopView ? '.desktopSectionTopDiv' : '.mobileFieldSection'
        );
        let blueBarInitValues =
            blueBarInit[commonUtils.getVerticalName() + (!this.isDesktopView ? '_mobile' : '')][sectionId];

        let currentSerialized = this.sanitizeSerializedFields(sectionId);

        if (currentSerialized === blueBarInitValues) {
            $section.removeClass('searchSectionChanged');
            $section.find('.resetAdvField').hide();
            // Reset field header value
            if (-1 === $.inArray(sectionId, ['postedByFields', 'statusTypeFields', 'vehicleTypeFields'])) {
                // Posted by/Ad type fields and vehicleType skipped to keep their values in the field header
                $section.find('.advance-search-tool__row_col-data-value').text('');
            }
        } else {
            $section.addClass('searchSectionChanged');
            $section.find('.resetAdvField').show();
        }

        setTimeout(function () {
            advanceSearchCommon.enableDisableResetLink();
        }, 5);
    },
    showResetIconOnLoad(isResized) {
        const wasResized = isResized || false;
        if (wasResized) {
            $('.searchSectionChanged').find('.resetAdvField').hide();
        }

        $(`#advance_search ${this.isDesktopView ? '.desktopFieldSection' : '.mobileFieldSection'}`).each(function () {
            let currentSectionId = $(this).attr('id');

            let currentSerialized = advanceSearchCommon.sanitizeSerializedFields(currentSectionId);

            advanceSearchCommon.blueBar[currentSectionId] = currentSerialized;
            let blueBarInitValues =
                blueBarInit[commonUtils.getVerticalName() + (!advanceSearchCommon.isDesktopView ? '_mobile' : '')][
                    currentSectionId
                ];
            const $sectionId = $(`#${currentSectionId}`);
            const $container = $sectionId.closest(
                advanceSearchCommon.isDesktopView ? '.desktopSectionTopDiv' : '.mobileFieldSection'
            );

            if (advanceSearchCommon.blueBar[currentSectionId] === blueBarInitValues) {
                $container.removeClass('searchSectionChanged');
                $sectionId.closest('.searchSectionChanged').find('.resetAdvField').hide();
            } else {
                $container.addClass('searchSectionChanged');
                $sectionId.closest('.searchSectionChanged').find('.resetAdvField').show();
            }
        });

        // Show reset link if any section has changes
        if ($('.searchSectionChanged').length > 0) {
            $('#advance_search .resetWholeAdvSearchFields').removeClass('disabled-link');
            accessibility.updateDisabledLinkAttributes();
        } else {
            $('#advance_search .resetWholeAdvSearchFields').addClass('disabled-link');
            accessibility.updateDisabledLinkAttributes();
        }
    },
    checkPostedBy(event) {
        if (0 === $('.postedBy').filter(':checked').length) {
            event.preventDefault();
        }
    },
    expandCollapseLayerForMobileLayout(object) {
        if ($(globalThis).width() <= 699) {
            let $section = $(`#${object.closest('.post-ad__section').attr('id')}`);
            if ($section.hasClass('currentSection')) {
                $section.removeClass('currentSection post-ad__section_open');
            } else {
                $('.currentSection').removeClass('currentSection');
                $section.toggleClass('post-ad__section_open');
                $section.addClass('currentSection');
                $('html, body').animate(
                    {
                        scrollTop: $section.offset().top,
                    },
                    500
                );
            }
        }
    },
    expandCollapseLayers(object) {
        let isDebugOn = $('#app').data('adv-debug') === 'Y';

        if (isDebugOn) {
            alert(`VIEW = ${this.isDesktopView}, iOS = ${commonUtils.isiOS()}`);
        }

        // Field label/header common to mobile/desktop, prevent expand/collapse for desktop
        if (this.isDesktopView && object.hasClass('expandCollapseSectionMobile')) {
            return;
        }

        let classToShowHideSection = 'post-ad__section_open';
        let $section = $(`#${object.closest('.desktopSectionTopDiv').attr('id')}`);

        if (!this.isDesktopView) {
            classToShowHideSection = 'advance-search-tool__row_col-open';
            $section = object.parent('div');
        }

        if ($section.hasClass('currentSection')) {
            $section.removeClass(`currentSection ${classToShowHideSection}`);
        } else {
            $('.currentSection').removeClass('currentSection');
            $section.toggleClass(classToShowHideSection);
            $section.addClass('currentSection');
        }
    },
    changeFinlandOnly() {
        let $finlandOnly = $('#finlandOnly');

        advanceSearchCommon.changeLocationDropdown(true);
        advanceSearchCommon.showHideResetIcon('locationFields');

        if ($finlandOnly.is(':checked')) {
            let panelId = $('#finlandOnly').closest('[id^=panel]').data('panel-id');
            let $section = $(`#panel_${panelId}`).closest('.post-ad__section');
            $section.removeClass('advance-search__section_changed');
            $section.find('.resetAdvField').hide();
            if ($('#regionTownSelected option').length === 0) {
                let $regionTownSelected = $('#advance_search #regionTownSelected');
                $regionTownSelected.append(
                    `<option data-country="${COUNTRY_FINLAND_ID}" data-region="" data-town="" value="${COUNTRY_PREFIX}${COUNTRY_FINLAND_ID}" selected="selected">${Translations.country_finland}</option>`
                );
                $('#regionTownSelectedDiv').append(
                    `<div data-id="${COUNTRY_PREFIX}${COUNTRY_FINLAND_ID}" class="multiple-seleced-text removeRegionTownOpt">${Translations.country_finland}<span class="form-control__reset-btn">Remove</span></div>`
                );
                advanceSearchCommon.dispatchLocationChangeEvent();
            }
        }

        if ($('#regionTownSelected option').length === 0) {
            $('#addAnotherLocation, #advance_search #selectedLocationOptionValueCaption').hide();
        }
    },
    changeLocationDropdown(isChangeEvent) {
        let isFinlandOnly = $('#finlandOnly').is(':checked');
        let $town = $('#regionTown');
        let $options = '';
        $town.find('option').not(':first').remove();

        if (!isFinlandOnly) {
            $town.html($('.AllWithFinland').html());
            $options = $('#regionTown option[data-sort!="N"]');
            $options.detach().sort(function (optionOne, optionTwo) {
                let optionOneText = $(optionOne).text();
                let optionTwoText = $(optionTwo).text();
                let result = optionOneText < optionTwoText ? -1 : 0;
                return optionOneText > optionTwoText ? 1 : result;
            });
            $options.appendTo('#regionTown');
        } else {
            $town.html($('.finlandOnly').html());
        }

        if (isChangeEvent) {
            let isCounterCallRequired = false;
            $('#regionTownSelected option').each(function () {
                if ($(this).data('country') !== '' || $(this).data('region') === REGION_OUTSIDE_FINLAND_ID) {
                    isCounterCallRequired = true;
                    $(this).remove();
                    $(`#regionTownSelectedDiv [data-id='${this.value}']`).remove();
                }
            });

            if (isCounterCallRequired) {
                advanceSearchCommon.dispatchLocationChangeEvent();
            }
        }
    },
    regionTownSelect2Event() {
        $('#regionTown').on('select2:select', function () {
            advanceSearchCommon.showSelectedRegionTownOption();
            advanceSearchCommon.showHideResetIcon('locationFields');

            advanceSearchCommon.dispatchLocationChangeEvent();
        });
    },
    removeRegionTownOption(clickedElement) {
        let isFinlandOptionRemoved = clickedElement.data('id')
            ? clickedElement.data('id').toString().includes(COUNTRY_FINLAND_ID)
            : false;

        clickedElement.remove();
        $(`#regionTownSelected option[value="${clickedElement.data('id')}"]`).remove();
        if ($('.removeRegionTownOpt').length <= 0) {
            if (isFinlandOptionRemoved) {
                $('#advance_search #finlandOnly').prop('checked', false);
                advanceSearchCommon.changeFinlandOnly();
            }

            let locationSectionName = 'locationInformation';
            locationSectionName = this.isDesktopView ? 'basicInfoFields' : 'locationFields';

            const advanceSearchType = 'showHideResetIcon';
            advanceSearchCommon[advanceSearchType](locationSectionName);

            if ($('#regionTownSelected option').length === 0) {
                $('#addAnotherLocation, #advance_search #selectedLocationOptionValueCaption').hide();
            }
        }

        advanceSearchCommon.dispatchLocationChangeEvent();
        advanceSearchCommon.showHideAddLocationSelectionLink();
    },
    showSelectedRegionTownOption() {
        let displayText = '';
        let value = '';
        let $regionTownId = $('#regionTown');
        let $regionSelected = $('#regionTownSelected');
        let domicileId = $regionTownId.find(':selected').data('domicileid');
        let townId = $regionTownId.find(':selected').data('townid');
        let countryId = $regionTownId.find(':selected').data('countryid');
        let domicile = $regionTownId.find(':selected').data('domicile');
        let town = $regionTownId.find(':selected').data('town');
        let country = $regionTownId.find(':selected').data('country');

        $('#regionTownSelected option').each(function () {
            if (domicileId === REGION_OUTSIDE_FINLAND_ID || countryId === COUNTRY_FINLAND_ID) {
                $(this).remove();
                $(`#regionTownSelectedDiv [data-id='${this.value}']`).remove();
            } else if (domicileId || townId || countryId) {
                $(`#regionTownSelectedDiv [data-id='${REGION_OUTSIDE_FINLAND_ID}']`).remove();
                $regionSelected.find(`option[data-region='${REGION_OUTSIDE_FINLAND_ID}']`).remove();

                $(`#regionTownSelectedDiv [data-id='${COUNTRY_PREFIX}${COUNTRY_FINLAND_ID}']`).remove();
                $regionSelected.find(`option[data-country='${COUNTRY_FINLAND_ID}']`).remove();
            }

            if (
                ($(this).data('country') !== '' && $(this).data('country') === countryId) ||
                (domicileId === $(this).data('region') &&
                    domicileId !== '' &&
                    ('' === $(this).data('town') || '' === townId || $(this).data('town') === townId))
            ) {
                $(this).remove();
                $(`#regionTownSelectedDiv [data-id='${this.value}']`).remove();
            }
        });

        if (countryId > 0) {
            displayText += `${country}, `;
            value += `${COUNTRY_PREFIX + countryId},`;
        } else {
            if (domicileId > 0) {
                if (townId === '') {
                    displayText += `${domicile}, `;
                }
                value += `${domicileId},`;
            }

            if (townId > 0) {
                displayText += `${town}, `;
                value += `${townId},`;
            }
        }

        if (countryId === COUNTRY_FINLAND_ID) {
            $('#advance_search #finlandOnly').prop('checked', true);
            advanceSearchCommon.changeFinlandOnly();
        } else {
            value = value.slice(0, -1);
            displayText = displayText.slice(0, -2);
            $regionSelected.append(
                `<option data-country="${countryId}" data-region="${domicileId}" data-town="${townId}" value="${value}" selected="selected">${displayText}</option>`
            );
            $('#regionTownSelectedDiv').append(
                `<div data-id="${value}" class="multiple-seleced-text removeRegionTownOpt">${displayText}<span class="form-control__reset-btn ">Remove</span></div>`
            );
            $regionTownId.val('').trigger('change.select2');
            $('.advSearchRegionTownOptions, #selectedLocationOptionValueCaption').show();
        }
        advanceSearchCommon.showHideAddLocationSelectionLink();
    },
    setRegionTownSelect2NoResultText() {
        $('#regionTown').select2({
            placeholder: Translations.select,
            dropdownParent: $('.region-town-wrap'),
            containerCssClass: 'select2-customization',
            matcher: commonUtils.select2CustomMatch,
            language: {
                noResults() {
                    return Translations.no_result_text;
                },
            },
        });
    },
    saveSearchAgent(source) {
        if (!commonUtils.isUserLogin()) {
            almaTunnusLogin.init(source);
            return false;
        }

        $('#saveSearchAgent').val('Save');
        $('#advance_search').submit();
        return undefined;
    },
    updateCounterOnChangeElement(object) {
        let $sectionFieldId = object
            .closest(this.isDesktopView ? '.desktopFieldSection' : '.mobileFieldSection')
            .attr('id');
        // Delay added here for ajax based data loaded bit late so to avoid reset icon hide/show & search counter issue
        setTimeout(function () {
            advanceSearchCommon.showHideResetIcon($sectionFieldId);
        }, 10);
    },
    updateOptGroupOptions(elementId, optionGroupLabel, optionGroupData) {
        let $selectElement = $(`#advance_search #${elementId}`);
        let selected = '';

        let optionHtml = `<optgroup label="${optionGroupLabel}">`;
        $.each(optionGroupData, function (optGroupKey, optGroupValue) {
            selected = optGroupValue === $selectElement.val() ? 'selected' : '';
            optionHtml += `<option value="${optGroupValue}" data-id="${optGroupValue}"${selected}>${optGroupKey}</option>`;
        });

        optionHtml += '</optgroup>';
        $selectElement.append(optionHtml);
    },
    updateSelectElement(id, optionsData) {
        let $selectElement = $(`#advance_search #${id}`);
        let selected = '';
        // Remove current options except first
        $selectElement.find('option').not(':first').remove();
        $selectElement.find('optgroup').remove();

        $.each(optionsData, function (key, value) {
            if (typeof value !== 'object') {
                // Special case for BMW series model: Remove underscore from key because it added for sorting issue
                const normalizedKey = id === 'model' ? key.replace('_', '') : key;
                $selectElement.append(`<option value="${value}" ${selected}>${normalizedKey}</option>`);
                $selectElement.parent().show();
            } else {
                advanceSearchCommon.updateOptGroupOptions(id, key, value);
            }
        });
    },
    validatePriceRange(priceFrom, priceTo) {
        if (priceFrom.val() !== '' && priceFrom.val() < 1) {
            alert(Translations.price_validate_zero);
            priceFrom.val('');
        }

        if (priceTo.val() !== '' && priceTo.val() < 1) {
            alert(Translations.price_validate_zero);
            priceTo.val('');
        }

        let filterPriceFrom = priceFrom.val() > 0 ? Number.parseInt(priceFrom.val(), 10) : '';
        let filterPriceTo = priceTo.val() > 0 ? Number.parseInt(priceTo.val(), 10) : '';

        if (filterPriceFrom > filterPriceTo && filterPriceFrom !== '' && filterPriceTo !== '') {
            alert(Translations.price_validate);
            priceTo.val('').focus();
        }
    },
    enableDisableResetLink() {
        if ($('#advSearchContainer .searchSectionChanged').length) {
            $('#advance_search .resetWholeAdvSearchFields').removeClass('disabled-link');
            accessibility.updateDisabledLinkAttributes();
        } else {
            $('#advance_search .resetWholeAdvSearchFields').addClass('disabled-link');
            accessibility.updateDisabledLinkAttributes();
        }
    },
    showHideAddLocationSelectionLink() {
        if (this.isDesktopView) {
            return;
        }

        if ($('#regionTownSelected option').length === 0) {
            $('#addAnotherLocation').hide();
            $('#advance_search #selectedLocationOptionValueCaption').hide();
        } else {
            $('#addAnotherLocation').show();
        }
    },
    goToSectionFromTopLinkClicked(object) {
        let sectionId = object.data('section');
        let $sectionElement = $(`#advSearchContainer #${sectionId}`);

        if (!$sectionElement.hasClass('post-ad__section_open')) {
            $sectionElement.addClass('post-ad__section_open');
        }

        let section = document.getElementById(sectionId);

        if (section) {
            section.scrollIntoView({ behavior: 'smooth' });

            // Make the section focusable temporarily if it's not already
            if (!section.hasAttribute('tabindex')) {
                section.setAttribute('tabindex', '-1');
            }

            // Focus after a short delay to ensure scroll is complete
            setTimeout(() => {
                section.focus();
            }, 500);
        }
    },
    dispatchLocationChangeEvent() {
        globalThis.dispatchEvent(new Event('advanceLocationChange'));
    },
    /**
     * Toggle Select2 checkbox state using exact suffix match after last hyphen
     * This avoids the fragile $= (ends-with) CSS selector which could match unintended elements
     */
    toggleSelect2Checkbox(modelId, checked) {
        $(`.advance-search-tool__select2-checkbox .select2-results__option`)
            .filter(function () {
                const id = $(this).attr('data-select2-id');
                if (!id) return false;
                const lastHyphenIndex = id.lastIndexOf('-');
                return lastHyphenIndex !== -1 && id.substring(lastHyphenIndex + 1) === String(modelId);
            })
            .find('.select2-checkbox')
            .prop('checked', checked);
    },
};
